// Hooks
import { defineStore } from "pinia";
import { ref, computed } from "vue";

import { I_checkPhotoSetStatus_Return } from "@/hooks/requests/it4CheckPhotoSetStatus/it4CheckPhotoSetStatus.types";
import useExecutingStatus from "@/hooks/useExecutingStatus";

// Types
import type { I_OperatorExecuting } from "./operatorExecuting.types";

/**
 * * 🆂🆃🅾🆁🅴 [Operator Executing]
 * */
export const useOperatorExecutingStore = defineStore("operatorExecuting", () => {
    // |-------|
    // | STATE |
    // |-------|

    /** Статус обработки фотографий оператором */
    const status = ref<I_OperatorExecuting["status"]>("WAITING");

    /** Статус-процент пройденного времени от обработки фотографий оператором */
    const percent = ref<I_OperatorExecuting["percent"]>(0);

    // |----------|
    // | COMPUTED |
    // |----------|

    /** Текущий статус-текст обработки фотографий оператором */
    const currentStatusMessages = computed(() => {
        return useExecutingStatus(status.value);
    });

    const deviceDataAfterExecuting = ref<I_checkPhotoSetStatus_Return>(null);

    // |---------|
    // | METHODS |
    // |---------|

    /** Сбросить значения STORE на по-умолчанию */
    const restoreToDefault = () => {
        status.value = "WAITING";
        percent.value = 0;
        deviceDataAfterExecuting.value = null;
    };

    /** Запросить статус обработки фотографий оператором */
    const checkStatus = async () => {
        if (status.value === "WAITING") {
            status.value = "GRADING";
            return;
        }
        if (status.value === "GRADING") {
            status.value = "PROCESSED";
            return;
        }
    };

    // |-------|
    // | WATCH |
    // |-------|

    return {
        // * 🆂🆃🅾🆁🅴
        status,
        percent,
        deviceDataAfterExecuting,

        // * 🅲🅾🅼🅿🆄🆃🅴🅳
        currentStatusMessages,

        // * 🅼🅴🆃🅷🅾🅳🆂
        restoreToDefault,
        checkStatus,
    };
});
